<!-- Marketplace -->
<svg:path
    d="M108 530 L310 405 V381 L108 502 L108 530 Z"
    fill="var(--base-border-bg-1)" />
<svg:path
    d="M108 530 L310 410 V385 L108 505 L108 530 Z"
    fill="var(--wall-bg-2)" />

<svg:path
    d="M0 461 L108 530 L108 502 L0 437 V461 Z"
    fill="var(--base-border-bg-1)" />
<svg:path
    d="M0 466 L108 530 L108 505 L0 440 V466 Z"
    fill="var(--wall-bg-1)" />
    